(function ($) {
  // Initialize
  var openedClass = 'opened';
  var zopimLikeContact = $('.zopim-like-contact');
  var zopimLikeContactHeader = $('.zopim-like-contact-header', zopimLikeContact);

  // Update cursor to help user to click on banner
  // And toggle opened class on click
  zopimLikeContactHeader.css('cursor', 'pointer').on('click', function() {
    zopimLikeContact.toggleClass(openedClass);
  });

})(jQuery);